var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-cbd2912c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Rules.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Account/Rules.vue
// module id = 77
// module chunks = 0